import { CardExpiryElement } from '@stripe/react-stripe-js'
import createInput from './utils'

export const CardExpiryInput = createInput(CardExpiryElement)
